import {Box} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {useCallback} from 'react';

import {GetDeliveryNoteResponse} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {DmsDataGrid, WAREHOUSE_GRID_CODES, useTenant} from '@dms/shared';
import {OverviewTotalPrice} from '@dms/warehouse/shared-components';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface ListOfItemsTabProps extends RequiredTestIdProps {
  deliveryNoteId: string;
  deliveryNote: GetDeliveryNoteResponse | Nullish;
}

export function ListOfItemsTab(props: ListOfItemsTabProps) {
  const formatCurrency = useFormatCurrency();
  const tenant = useTenant();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => ({
      ...filter,
      deliveryNoteId: props.deliveryNoteId,
    }),
    [props.deliveryNoteId]
  );

  const totalPriceWithoutVat = formatCurrency(
    props.deliveryNote?.totalPrice?.withoutVat?.amount ?? 0,
    props.deliveryNote?.totalPrice?.withoutVat?.currency ?? tenant.tenantCurrency,
    2
  );

  const totalPriceWithVat = formatCurrency(
    props.deliveryNote?.totalPrice?.withVat?.amount ?? 0,
    props.deliveryNote?.totalPrice?.withVat?.currency ?? tenant.tenantCurrency,
    2
  );

  return (
    <Box height="100%">
      <Box height="95%">
        <DmsDataGrid
          gridCode={WAREHOUSE_GRID_CODES.deliveryNoteItems}
          queryModifier={queryModifier}
          data-testid={suffixTestId('deliveryNoteItems', props)}
        />
      </Box>
      <OverviewTotalPrice
        totalPriceLabel={i18n.t('entity.warehouse.labels.totalPrice')}
        totalPriceWithoutVat={totalPriceWithoutVat}
        totalPriceWithVat={totalPriceWithVat}
        data-testid={suffixTestId('totalPrice', props)}
      />
    </Box>
  );
}
